import React from "react";
import {
  Box,
  List,
  ListItem,
  Typography,
  ListItemText,
  ListItemIcon,
  Container,
} from "@mui/material";
import { motion } from "framer-motion";

// import Heading from "../Heading";
import GroupIcon from "@mui/icons-material/Group";
import CampaignIcon from "@mui/icons-material/Campaign";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import CAREERGRPHS from "../../assets/Graphics/Career.png";

// import { getMeaning } from "../../utils/localization";
// import { GRAPHICS } from "../../constants/AssetsPath";

// Animation Variants
const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, when: "beforeChildren", staggerChildren: 0.2 },
  },
};

const sectionVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const iconVariants = {
  hover: { scale: 1.2, rotate: 10, transition: { duration: 0.3 } },
};

// Data for rendering value sections
const VALUE_SECTIONS = [
  {
    icon: <GroupIcon sx={{ color: "#000" }} />,
    title: "People First",
    items: [
      "Our Customers – Customer Centricity.",
      " Our Team – Embrace, Trust, Respect",
      " Our Partners – Win-Win, Mutual Growth",
      " Our Partners – Open, honest, fair and transparent relationship",
    ],
  },
  {
    icon: <CampaignIcon sx={{ color: "#000" }} />,
    title: "Resilience",
    items: [
      "Never Backing Down – Determination, Relentlessness and Resilience",
    ],
  },
  {
    icon: <EmojiObjectsIcon sx={{ color: "#000" }} />,
    title: "Innovation",
    items: [
      " Strategic Agility – Agile and Adaptive",
      "Continuous Improvement – Be curious, Think of new ideas and try to make it better",
    ],
  },
  {
    icon: <TrackChangesIcon sx={{ color: "#000" }} />,
    title: "Ambition",
    items: [
      "Audacity – Ambitious goals. Our motto is 'Go Big or Go Home'!",
      "Entrepreneurial Mindset – Take Initiative, Be decisive",
    ],
  },
];

const AcrossValue = () => {
  return (
    <Box
      sx={{
        py: 4,
        alignContent: "center",
        textAlign: "center",
        bgcolor: "#fff6f1",
      }}
    >
      <Box ml={-1}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: "500",
            fontSize: "2rem",
            color: "#000",
            textAlign: "center",
            mb: 2,
          }}
        >
          Across Assist Value
        </Typography>
        <Typography
          variant="body1"
          component={motion.div}
          variants={sectionVariants}
          sx={styles.description}
        >
          An Across is a torch bearing hero who is righteous, impeccable and
          winsome entrepreneur
        </Typography>
      </Box>

      <Box
        component={motion.div}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        sx={styles.wrapper}
      >
        <Container maxWidth="lg" sx={{ display: "flex", flexWrap: "nowrap" }}>
          {/* Left: Text Details */}
          <Box sx={styles.details}>
            {VALUE_SECTIONS.map((section, index) => (
              <Box
                key={index}
                mb={1.5}
                component={motion.div}
                variants={sectionVariants}
              >
                <Box sx={styles.iconLabel}>
                  <ListItemIcon
                    sx={{ minWidth: 36 }}
                    component={motion.div}
                    variants={iconVariants}
                    whileHover="hover"
                  >
                    {section.icon}
                  </ListItemIcon>
                  <Typography variant="h6" sx={styles.title}>
                    {section.title}
                  </Typography>
                </Box>
                <List dense>
                  {section.items.map((item, idx) => (
                    <ListItem
                      key={idx}
                      disablePadding
                      component={motion.div}
                      variants={itemVariants}
                    >
                      <ListItemText
                        primary={`• ${item}`}
                        primaryTypographyProps={styles.listItemText}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </Box>

          {/* Right: Image */}
          <Box
            component={motion.img}
            src={CAREERGRPHS}
            alt="Thriwe Tree Values"
            sx={styles.image}
            variants={imageVariants}
          />
        </Container>
      </Box>
    </Box>
  );
};

export default AcrossValue;

// Style object
const styles = {
  wrapper: {
    px: { xs: 2, md: 1 },
    py: { xs: 2, md: 3 },
    // backgroundColor: "#f9f4f2",
  },
  details: {
    flex: 1,
    pr: { md: 4 },
  },
  description: {
    mb: 2,
    fontFamily: '"Poppins", serif',
    color: "black",
    fontSize: { xs: "0.9rem", md: "0.96rem" },
  },
  iconLabel: {
    display: "flex",
    alignItems: "center",
    mb: -1,
  },
  title: {
    color: "#000",
    fontFamily: '"Poppins", serif',
  },
  listItemText: {
    fontFamily: '"Poppins", serif',
    mb: -0.5,
    fontSize: { xs: "0.82rem", md: "0.9rem" },
  },
  image: {
    flex: 1,
    maxWidth: "36vw",
    width: "100%",
    height: "auto",
    display: "block",
    ml: { md: 4 },
    mt: { xs: 4, md: 0 },
  },
};
